import Config from '../../config.json';

function getBearerTokenAuthEnabledConfig(): string | undefined {
  if (process.env.REACT_APP_BEARER_TOKEN_AUTH_ENABLED) {
    return process.env.REACT_APP_BEARER_TOKEN_AUTH_ENABLED;
  }

  if (
    Config.REACT_APP_BEARER_TOKEN_AUTH_ENABLED &&
    Config.REACT_APP_BEARER_TOKEN_AUTH_ENABLED !==
      'ENV_'.concat('BEARER_TOKEN_AUTH_ENABLED')
  ) {
    return Config.REACT_APP_BEARER_TOKEN_AUTH_ENABLED;
  }

  return undefined;
}

export function isBearerTokenAuthEnabled(): boolean {
  return getBearerTokenAuthEnabledConfig()?.toLowerCase() !== 'false';
}

export function isCookieAuthEnabled(): boolean {
  return !isBearerTokenAuthEnabled();
}

export function getLogoutUrl(): string | undefined {
  if (process.env.REACT_APP_LOGOUT_URL) {
    return process.env.REACT_APP_LOGOUT_URL;
  }

  if (
    Config.REACT_APP_LOGOUT_URL &&
    Config.REACT_APP_LOGOUT_URL !== 'ENV_'.concat('LOGOUT_URL')
  ) {
    return Config.REACT_APP_LOGOUT_URL;
  }

  return undefined;
}
